
export default {
  name: 'NoContent',
  props: {
    text: {
      required: true
    }
  }
};
